import { Grid, InputAdornment, styled, TextField, Typography } from '@mui/material';
import Appbar from 'components/appbar/Appbar';
import FilterBox from 'components/filter-box/FilterBox';
import ModuleLoading from 'components/loading/ModuleLoading';
import TableLoading from 'components/loading/TableLoading';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import Pagination from 'components/pagination/Pagination';
import { useApp } from 'hooks/app';
import PaginationProvider from 'hooks/pagination';
import useSearch from 'hooks/search';
import useTableOrder from 'hooks/tableOrder';
import React, { useEffect, useState } from 'react';
import { api } from 'services/api';
import { AccessRule as AccessRuleType } from 'types/accessRule';
import AccessRulesActions from './AccessRulesActions';
import AccessRulesModule from './list/module/AccessRulesList';
import AccessRulesTable from './list/table/AccessRulesList';
import NoData from 'components/no-data/NoData';

const AccessRules: React.FC = () => {
  const [rules, setRules] = useState<AccessRuleType[]>([]);
  const [loading, setLoading] = useState(true);
  const app = useApp();
  const [displayMode, setDisplayMode] = useState<'list' | 'module'>(
    app.isMobile || app.windowWidth < 930 ? 'module' : 'list',
  );
  const search = useSearch();
  const [filtered, setFiltered] = useState<AccessRuleType[]>([]);
  const [orderedIndex, sort] = useTableOrder();

  useEffect(() => {
    setDisplayMode(app.isMobile || app.windowWidth < 930 ? 'module' : 'list');
  }, [app.isMobile, app.windowWidth]);

  useEffect(() => {
    setLoading(true);
    api
      .get<AccessRuleType[]>('/access-rules')
      .then(response => {
        setRules(response.data);
        setFiltered(response.data);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function handleSearch(searchValue: string) {
    if (searchValue) {
      const _rules = search(searchValue, 'title', rules);
      setFiltered(_rules);
      return;
    }

    setFiltered(rules);
  }

  function handleSort(index: string) {
    const f = sort(index, filtered);
    setFiltered(f);
  }

  return (
    <>
      <Appbar title="Regras de acesso" ActionsComponent={<AccessRulesActions />} />
      <PageHeaderActions
        title="Regras de acesso"
        description="Gestão das regras de acesso do sistema"
        ActionComponent={<NewRecordButton label="Nova regra de acesso" to="/access-rule" />}
      />
      <FilterBox>
        <Grid size={app.isMobile || app.windowWidth < 960 ? 12 : 4}>
          <TextField
            fullWidth
            label="Pesquisar"
            placeholder="Digite sua pesquisa"
            autoFocus
            onChange={e => handleSearch(e.target.value)}
          />
        </Grid>
      </FilterBox>
      {loading ? (
        displayMode === 'list' ? (
          <TableLoading />
        ) : (
          <ModuleLoading />
        )
      ) : filtered.length === 0 ? (
        <NoData message="Nenhuma regra de acesso criada" />
      ) : (
        <PaginationProvider>
          <div>
            {displayMode === 'list' ? (
              <AccessRulesTable accessRules={filtered} />
            ) : (
              <AccessRulesModule accessRules={filtered} />
            )}
            <Pagination onChangePage={e => undefined} onChangeRowsPerPage={e => undefined} count={filtered.length} />
          </div>
        </PaginationProvider>
      )}
    </>
  );
};

export default AccessRules;
